import { render, staticRenderFns } from "./AutoSelect.vue?vue&type=template&id=22328c13&"
import script from "./AutoSelect.vue?vue&type=script&lang=js&"
export * from "./AutoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports